// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-button {
  border: 0;
  background-color: #426bac;
  border-radius: 2px;
  box-shadow: 4px 4px 20px rgba(41, 73, 123, 0.5019607843);
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.default-button.separator-right {
  margin-right: 20px;
}
.default-button.full-width {
  width: 100%;
  margin: 0;
}
.default-button:hover {
  background-color: #00b3e7;
}
.default-button:focus {
  outline: none;
}
.default-button.disabled {
  cursor: default;
  background-color: #495057;
}
.default-button .btn-title.hidden {
  visibility: hidden;
}
.default-button .btn-title .action-button-icon {
  margin-right: 10px;
}
.default-button .spinner-border {
  position: absolute;
  height: 24px;
  width: 24px;
}`, "",{"version":3,"sources":["webpack://./application/shared/components/actionButton/styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;EACxD,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".default-button {\n  border: 0;\n  background-color: #426bac;\n  border-radius: 2px;\n  box-shadow: 4px 4px 20px rgba(41, 73, 123, 0.5019607843);\n  color: #fff;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 8px 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.default-button.separator-right {\n  margin-right: 20px;\n}\n.default-button.full-width {\n  width: 100%;\n  margin: 0;\n}\n.default-button:hover {\n  background-color: #00b3e7;\n}\n.default-button:focus {\n  outline: none;\n}\n.default-button.disabled {\n  cursor: default;\n  background-color: #495057;\n}\n.default-button .btn-title.hidden {\n  visibility: hidden;\n}\n.default-button .btn-title .action-button-icon {\n  margin-right: 10px;\n}\n.default-button .spinner-border {\n  position: absolute;\n  height: 24px;\n  width: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
